// extracted by mini-css-extract-plugin
export default {"list":"Chart_list__NMCs7","category":"Chart_category__e3D30","price":"Chart_price__1PG96","description":"Chart_description__hXq3k","item":"Chart_item__jf3ga"};